import { ANCHOR_TAG_NAME, SPINNER_CLASSNAME } from './constants';
import processAnchorElements from './processAnchorElementsFromHtmlContent';
import { OWA_REFERENCE_ATTACHMENTS_ID } from './shouldProcessLink';
import LinkPlugin from '../plugin/LinkPlugin';
import { LinkIdContainer } from '../schema/LinkIdContainer';
import { AnchorElementsSource } from '../types/AnchorElementsSource';
import { trace } from 'owa-trace';

const CLASS_QUERY_PREFIX = '.';
const ID_QUERY_PREFIX = '#';

export async function processAllLinksInEditor(
    linkPlugin: LinkPlugin,
    linkIdContainer: LinkIdContainer,
    linkIdsWithSpinner: string[],
    shouldChangeLinkId: boolean,
    anchorElementsSource: AnchorElementsSource
) {
    trace.info('LinkPlugin.processAllLinksInEditor');
    const allLinks = linkPlugin.editor.queryElements(ANCHOR_TAG_NAME);
    const hiddenReferenceAttachments = linkPlugin.editor.queryElements(
        ID_QUERY_PREFIX + OWA_REFERENCE_ATTACHMENTS_ID
    );

    removeInvalidSpinner(linkPlugin, linkIdsWithSpinner);
    await processAnchorElements(
        allLinks,
        hiddenReferenceAttachments,
        anchorElementsSource,
        linkPlugin,
        linkIdContainer,
        linkIdsWithSpinner,
        shouldChangeLinkId,
        false /* shouldTryBeautify */
    );
}

function removeInvalidSpinner(linkPlugin: LinkPlugin, linkIdsWithSpinner: string[]) {
    linkPlugin.editor.queryElements(CLASS_QUERY_PREFIX + SPINNER_CLASSNAME, spinner => {
        if (linkIdsWithSpinner.indexOf(spinner.parentElement.id) === -1) {
            spinner.parentElement.removeChild(spinner);
        }
    });
}
